/* ==========================================================================
   JM27 kategoriside (sep 2026)
   - "Se de næste N": henter næste side af SAMME sektion via Section Rendering
     (?page=N&section_id=<sektionens id>) og tilføjer produkterne på stedet.
     Serveren nummererer (01, 02 …) og lægger 7-mønstret pr. side; efter hver
     tilføjelse regnes begge forfra fra første produkts nummer (reflow), fordi
     "Vis sidst"-produkter springes over på deres egen side og ellers ville
     give spring i numrene og huller i mønstret. Fokus flyttes til det første
     nye produkt.
     Temaets <loadmore-button> bruges bevidst ikke (den genindlæser siden ved
     2. klik).
   - Underkategori-rækken på mobil: den aktive kategori rulles frem.
   - Kategoriteksten foldes sammen (kun med JS — uden JS vises hele teksten).
   ========================================================================== */
(function () {
  'use strict';
  /* Tre sektioner loader filen — kør kun én gang */
  if (window.__jm27Collection) return;
  window.__jm27Collection = true;

  function reflow(grid) {
    var items = grid.querySelectorAll('[data-jm27-ex-item]');
    if (!items.length) return;
    var base = parseInt(items[0].getAttribute('data-jm27-n'), 10) || 1;
    items.forEach(function (item, i) {
      var n = base + i;
      var slot = ((n - 1) % 7) + 1;
      for (var k = 1; k <= 7; k++) item.classList.remove('s' + k);
      item.classList.add('s' + slot);
      item.setAttribute('data-jm27-n', String(n));
      var no = item.querySelector('.jm27-sign__no');
      if (no) no.textContent = n < 10 ? '0' + n : String(n);
    });
  }

  function initMore(root) {
    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-jm27-more]');
      if (!link || !root.contains(link)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault();
      if (link.classList.contains('is-loading')) return;
      var sid = root.getAttribute('data-section-id');
      var grid = root.querySelector('[data-jm27-ex-grid]');
      var wrap = link.closest('[data-jm27-more-wrap]');
      var status = wrap && wrap.querySelector('[data-jm27-more-status]');
      var url = new URL(link.getAttribute('href'), window.location.href);
      url.searchParams.set('section_id', sid);
      link.classList.add('is-loading');
      link.setAttribute('aria-busy', 'true');
      if (status) status.textContent = 'Henter flere produkter …';
      fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('[data-jm27-ex-item]');
          var first = null;
          items.forEach(function (item) {
            var node = document.importNode(item, true);
            grid.appendChild(node);
            if (!first) first = node;
          });
          reflow(grid);
          var nextWrap = doc.querySelector('[data-jm27-more-wrap]');
          if (nextWrap && wrap) {
            wrap.replaceWith(document.importNode(nextWrap, true));
          } else if (wrap) {
            wrap.remove();
          }
          var live = root.querySelector('[data-jm27-more-status]');
          if (live) live.textContent = items.length + ' produkter mere er vist.';
          if (first) {
            var a = first.querySelector('a');
            if (a) a.focus({ preventScroll: true });
          }
        })
        .catch(function () {
          /* Fald tilbage til en almindelig sideindlæsning */
          window.location.href = link.getAttribute('href');
        });
    });
  }

  function initSubnav(list) {
    var active = list.querySelector('.is-active');
    if (!active || list.scrollWidth <= list.clientWidth) return;
    var li = active.closest('li') || active;
    var left = li.offsetLeft - 20;
    if (left > 0) list.scrollLeft = left;
  }

  function initFold(box) {
    var body = box.querySelector('[data-jm27-fold-body]');
    var btn = box.querySelector('[data-jm27-fold-toggle]');
    if (!body || !btn) return;
    box.classList.add('jm27-fold-ready');
    /* Kort tekst → ingen fold */
    if (body.scrollHeight <= body.clientHeight + 40) {
      box.classList.remove('jm27-fold-ready');
      return;
    }
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = !body.classList.contains('is-open');
      body.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) {
        var top = box.getBoundingClientRect().top + window.scrollY - 120;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-jm27-ex]').forEach(function (root) {
      if (root.hasAttribute('data-jm27-ready')) return;
      root.setAttribute('data-jm27-ready', '');
      initMore(root);
    });
    document.querySelectorAll('[data-jm27-subnav]').forEach(function (list) {
      if (list.hasAttribute('data-jm27-ready')) return;
      list.setAttribute('data-jm27-ready', '');
      initSubnav(list);
    });
    document.querySelectorAll('[data-jm27-fold]').forEach(function (box) {
      if (box.hasAttribute('data-jm27-ready')) return;
      box.setAttribute('data-jm27-ready', '');
      initFold(box);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
